export default angular.module('document.helper', [])
    .factory('Data', function () {
        return {
            schema: "I'm data from a service"
        };
    })
    .directive('smartXeditable', function () {

        function link(scope, element, attrs, ngModel) {

            let defaults = {
            };

            let inited = false;

            let initXeditable = function () {

                let options = scope.options || {};
                let initOptions = angular.extend(defaults, options);

                // $log.log(initOptions);
                element.editable('destroy');
                element.editable(initOptions);
            };

            scope.$watch("options", function (newValue) {

                if (!newValue) {
                    return false;
                }

                initXeditable();

                // $log.log("Options changed...");

            }, true);

        }

        return {
            restrict: 'A',
            require: "ngModel",
            scope: {
                options: "="
            },
            link: link

        };
    });
